import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CommonModel from "../../components/dialog/Common";
import { getSearchdata } from '../../utils/common';
import { INSTAGRAM_TYPE_WITH_CAPS, YOUTUBE_TYPE_WITH_CAPS, getFixedValue } from "../../utils/constant";
import { getInfluencerListFordashboard } from './action';
import { updateDashboard } from './dashboardSlice';
import SearchBox from "./searchBox";

function EnhancedTableHead(props) {
  const { order, orderBy } = props;
  const {
    filters
  } = useSelector((state) => state.dashboardSlice);

  const headCells = [
    {
      id: "profile",
      numeric: false,
      disablePadding: true,
      label: "Profiles",
      type: "",
    },
    {
      id: "followers",
      numeric: false,
      disablePadding: true,
      label: filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? "Followers" : "Subscribers",
      type: "",
    },
    {
      id: "avg_likes",
      numeric: false,
      disablePadding: true,
      label: "Avg Likes",
      type: "",
    },
    {
      id: "avg_reel",
      numeric: false,
      disablePadding: true,
      label: filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? "Avg reel views" : "Avg views",
      type: "",
    },
    {
      id: "avg_comment",
      numeric: false,
      disablePadding: true,
      label: "Avg Comment",
      type: YOUTUBE_TYPE_WITH_CAPS,
    },
    {
      id: "ER",
      numeric: false,
      disablePadding: true,
      label: "ER",
      type: INSTAGRAM_TYPE_WITH_CAPS,
    },
    {
      id: "category",
      numeric: false,
      disablePadding: true,
      label: "Category",
      type: "",
    },
    {
      id: "location",
      numeric: false,
      disablePadding: true,
      label: "Location",
      type: "",
    },

    {
      id: "categories",
      numeric: false,
      disablePadding: true,
      label: "Categories",
      type: "",
    }
  ];

  return (
    <TableHead className="hideActionSort" >
      <TableRow sx={{background:'#DBECFF !important',height: "50px", "& th": {
                                backgroundColor: "inherit !important"
                              },}}>
        {headCells.filter((headCell) => {
          return headCell.type === "" || headCell.type.toLowerCase() === filters?.platform?.toLowerCase();
        }).map((headCell) => {
          return (
            <TableCell
            sx={{position:'sticky',top:'0',zIndex:10,}}
              key={headCell?.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

const MemoizedTableHead = memo(EnhancedTableHead);


export default function InfluencersListing() {


  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [open, setOpen] = useState(false);
  const [openTooltipIndexes, setOpenTooltipIndexes] = useState([]);
  const {
    sort_key,
    totalCount,
    filters,
    list,page,showLoading
  } = useSelector((state) => state.dashboardSlice);
  const tooltipRefs = useRef([]);
  const currentPage = useRef(parseInt(page || '0'));
  const observerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const handleDocumentClick = (event) => {
    const clickedOutsideAllTooltips = tooltipRefs.current.every(ref => ref && !ref.contains(event.target));
    if (clickedOutsideAllTooltips) {
      setOpenTooltipIndexes([]);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);
  const dispatch = useDispatch();

  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";

    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    dispatch(
      updateDashboard({
        sort_type: isAsc ? "asc" : "desc",
        sort_key: property,
      }),
    );

  };

  useEffect(() => {
    dispatch(
      updateDashboard({
        filters: getSearchdata()
      }),
    );
  }, [])


  useEffect(() => {
    currentPage.current = parseInt(page || '0');
  }, [page]);
  const loadMoreItems = useCallback(() => {
    if (loading || !hasMore) return;
    setLoading(true);
    const nextPage = currentPage.current + 1;
    currentPage.current = nextPage;
    setTimeout(() => {
      dispatch(updateDashboard({ showLoading:false,limit: 30, page: nextPage }));
      dispatch(getInfluencerListFordashboard());
    }, 1000);
    setLoading(false);
  }, [loading, hasMore, dispatch]);

  useEffect(() => {
    if (!observerRef.current || !hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading) {
          loadMoreItems();
        }
      },
      { root: null, threshold: 1.0 }
    );

    const ref = observerRef.current;
    observer.observe(ref);

    return () => observer.disconnect();;
  }, [hasMore, loading, loadMoreItems, list?.length]);


  useEffect(() => {
    if (list.length >= totalCount) {
      setHasMore(false);
    }
    else {
      setHasMore(true);
    }
  }, [list?.length, totalCount]);

  return (
    <div style={{position:'relative'}}>
    <SearchBox/>
      <Stack direction={"column"} gap={2} sx={{ position: 'relative', top: '0px' }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            border: '0px solid rgba(170, 170, 170, 0.3)',
            borderRadius: '0px',
          }}>
          <Paper sx={{ width: '100%', height: "100%",}}>
            <TableContainer sx={{
              maxHeight: "77vh",
              overflowY: "auto",
              position: "relative",
            }}>
              <Table stickyHeader
                aria-label="sticky table"
              >
                <MemoizedTableHead
                  order={order}
                  orderBy={sort_key}
                  onRequestSort={handleRequestSort}
                  numSelected={0}
                  onSelectAllClick={function (

                  ) {
                    throw new Error("Function not implemented.");
                  }}
                />
                <TableBody>
                  {list?.length > 0 ? (
                    list?.map((row, index) => {
                      let categrories = JSON.parse(row?.profileNiche || [])?.length > 0 ? JSON.parse(row?.profileNiche)?.map((v) => v?.option).toString() : "";
                      return (
                        <TableRow
                          hover
                          ref={index === list.length - 1 ? observerRef : null}
                          role="checkbox"
                          tabIndex={-1}
                          key={row?.name}
                          className={"tableRow"}
                          sx={{
                            "&:hover": {
                              backgroundColor: '#F0F7FF !important', "& td": {
                                backgroundColor: "inherit !important"
                              },
                            }, height: '60px'
                          }}
                        >
                          <TableCell component="td" scope="row" >
                            <Stack direction={"row"} spacing={2}><div class="MuiAvatar-root MuiAvatar-circular css-1nn861f-MuiAvatar-root"><img alt="" style={{ height: '35px', width: '35px', borderRadius: "100px" }} src={row.picture ? row.picture : "/profile.jpg"} className="MuiAvatar-img" /></div>
                              <Link className="text-decoration-none" target='_blank' style={{ fontSize: '13px', paddingTop: 7, fontWeight: '500', letterSpacing: '0px' }} onClick={(e) => {
                                e.preventDefault();
                                window.open("/userManagement/details/" + row.id, '_blank');
                              }} >{row?.name}</Link>
                            </Stack>

                          </TableCell>
                          <TableCell component="td" scope="row">
                            {getFixedValue(row?.followers) || "N/A"}

                          </TableCell>
                          <TableCell component="td" scope="row">
                            {getFixedValue(row?.Engagement?.posts?.avg_likes) || "N/A"}
                          </TableCell>

                          <TableCell align="left">
                            {filters?.platform === INSTAGRAM_TYPE_WITH_CAPS ? getFixedValue(row?.Engagement?.reels?.avg_views) : getFixedValue(row?.Engagement?.posts?.avg_views) || "N/A"}
                          </TableCell>
                          {filters?.platform === INSTAGRAM_TYPE_WITH_CAPS && <TableCell align="left">

                            {getFixedValue(row?.Engagement?.posts?.engagement_rate) || "N/A"}
                          </TableCell>}

                          {filters?.platform === YOUTUBE_TYPE_WITH_CAPS && <TableCell align="left">

                            {getFixedValue(row?.Engagement?.posts?.avg_comments)}
                          </TableCell>}
                          <TableCell align="left">
                            {row?.creatorCategory || "N/A"}
                          </TableCell>
                          <TableCell align="left">
                            {row?.location ? 
                              <Tooltip
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "rgba(97, 97, 97, 0.9) !important",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      padding: "5px !important",
                                      borderRadius: "6px",
                                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: "rgba(97, 97, 97, 0.9) !important",
                                      "&::before": {
                                        backgroundColor: "rgba(97, 97, 97, 0.9)",
                                      },
                                    },
                                  },
                                }}
                                title={row?.location}
                                arrow={true}
                              >
                                {row?.location.toString().length > 20 ? row?.location?.slice(0, 20) + '...' : row?.location}
                              </Tooltip>
                            : "N/A"}
                          </TableCell>
                          <TableCell align="left" >
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                              {categrories.split(",")?.map((option, index) => (
                                <>     {option ?
                                  <Tooltip
                                    title={option}
                                    arrow
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "rgba(97, 97, 97, 0.9) !important",
                                          color: "white",
                                          fontSize: "12px",
                                          fontWeight: "500",
                                          padding: "5px !important",
                                          borderRadius: "6px",
                                          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                                        },
                                      },
                                      arrow: {
                                        sx: {
                                          color: "rgba(97, 97, 97, 0.9) !important",
                                          "&::before": {
                                            backgroundColor: "rgba(97, 97, 97, 0.9)",
                                          },
                                        },
                                      },
                                    }}
                                  >
                                    <Chip
                                      key={option}
                                      label={option.length > 20 ? option?.slice(0, 20) + '...' : option}
                                      sx={{
                                        display: (index > 1 ? "none" : "block  "),
                                        background: 'white !important', color: '#726C6C !important',
                                        borderRadius: '62px', border: '1px solid #CCCBCB', fontSize: '14px', fontWeight: '500',
                                        padding: "5px 8px", height: '32px', "&:hover": {
                                          background: 'rgba(0, 0, 0, 0.04) !important',
                                        }
                                      }}
                                    /></Tooltip> : "NA"}
                                </>
                              ))}
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    !showLoading && <TableRow colSpan={10}>
                      <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                        <Typography
                          color="inherit"
                          variant="subtitle1"
                          alignItems={"center"}
                          component="h3"
                        >
                          No Data found!
                        </Typography>

                      </TableCell>
                    </TableRow>
                  )}
                     {hasMore && (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        {loading ? <CircularProgress size={24} /> : "Loading more..."}
                      </TableCell>
                    </TableRow>
                  )}
                      </TableBody>
              </Table>

            </TableContainer>
            <hr />
          </Paper>
          <CommonModel
            open={open}
            handleDialogClose={() => setOpen(false)}
            dialogTitle={"Remove Company"}
            dialogPara={`Are you sure you want to remove this company? `}
            nvYes={"Submit"}
            nvCancel={"Cancel"}
            yesHandle={() => {
              setOpen(false);
            }}
          />
        </Box>
      </Stack>
    </div>
  );
}
